import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import useApi from "../../CustomHooks/useApi";
import WalletOverview from "../../ResuableCompoment/Balance";

import ServiceHub from "../../ResuableCompoment/Services";
import useGeoLocation from "../../CustomHooks/useGeoLocation";
import ImageCarousel from "../../ResuableCompoment/ImageCarousel";
import { openPrint } from "../../Store/Slices/printSlice";
import PrintPopup from "../../ResuableCompoment/PrintPopup";
import LoaderCustom from "../../components/LoaderCustom";
import TickerBanner from "./TickerBanner";
import { 
  Printer, 
  ArrowUpRight, 
  Clock3, 
  CheckCircle2, 
  XCircle, 
  AlertCircle, 
  ReceiptText,
  Copy,
  Loader
} from "lucide-react";

import { Sparkles, Zap, ShieldCheck, X } from "lucide-react";
// import Loader from "../Loader";
const LocationPopup = () => {
  return (
    <div className="fixed inset-0 z-[999] bg-black/40 flex items-center justify-center">
      <div className="bg-white rounded-xl p-6 w-[90%] max-w-md shadow-xl">
        <h2 className="text-lg font-semibold mb-3">
          📍 स्थान अनुमति आवश्यक / Location Permission Required
        </h2>

        <p className="text-sm text-slate-700 mb-4">
          आपने स्थान (लोकेशन) की अनुमति प्रदान नहीं की है।
          डैशबोर्ड का उपयोग करने के लिए स्थान अनुमति आवश्यक है।
          <br />
          <span className="text-slate-600">
            You have not allowed location access. Location permission is required
            to use the dashboard.
          </span>
        </p>

        <div className="text-sm text-slate-600 space-y-2">
          <p className="font-medium">
            स्थान अनुमति सक्षम करने की प्रक्रिया / Steps to enable location:
          </p>

          <ul className="list-disc pl-5 space-y-1">
            <li>
              ब्राउज़र के एड्रेस बार के पास बने 🔒 लॉक चिन्ह पर क्लिक करें।
              <br />
              <span className="text-slate-500">
                Click the 🔒 lock icon near the browser address bar.
              </span>
            </li>
            <li>
              <b>स्थान (Location)</b> विकल्प को <b>अनुमति दें (Allow)</b> पर सेट करें।
              <br />
              <span className="text-slate-500">
                Set the <b>Location</b> option to <b>Allow</b>.
              </span>
            </li>
            <li>
              इसके बाद पृष्ठ को <b>रीफ़्रेश</b> करें।
              <br />
              <span className="text-slate-500">
                Refresh the page after enabling permission.
              </span>
            </li>
          </ul>
        </div>

        <div className="mt-4 text-xs text-slate-500">
          नोट: यदि आप मोबाइल का उपयोग कर रहे हैं, तो ब्राउज़र की सेटिंग्स में जाकर
          स्थान अनुमति सक्षम करें।
          <br />
          <span className="text-slate-400">
            Note: If you are using a mobile device, please enable location
            permission from the browser settings.
          </span>
        </div>
      </div>
    </div>
  );
};



const RetailerDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const role = useSelector((s) => s.auth.employeeDetails?.role);
  const [ledger, setLedger] = useState([]);
  const [loadingLedger, setLoadingLedger] = useState(false);

  const mid = useSelector((s) => s.auth.employeeDetails?.username);
  const { fetchLocation, permissionDenied, location } = useGeoLocation();
  const { callApi: fetchLedger } = useApi("/admin/transactions/retailer/recent-transactions", "GET");

  const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);

  useEffect(() => {
    const allowedRoles = ["MERCHANT", "INDEPENDENT_MERCHANT"];

    if (!allowedRoles.includes(role)) {
      navigate("/");
    }

    // 🔁 Sirf tab fetch jab Redux + localStorage dono empty ho
    if (!location) {
      fetchLocation();
    }
  }, []);


  useEffect(() => {

  const popupSeen = localStorage.getItem("subscription_popup_seen");

  if (!popupSeen) {
    setShowSubscriptionPopup(true);
  }

}, []);

const closeSubscriptionPopup = () => {

  localStorage.setItem("subscription_popup_seen", "true");

  setShowSubscriptionPopup(false);
};



  useEffect(() => {
    const loadLedger = async () => {
      if (!mid) return;
      setLoadingLedger(true);

      try {
        const res = await fetchLedger(null, `?mid=${mid}`);

        // ✅ Sirf data object uthao
        const onlyData = res?.slice(0, 5).map(item => item.data);

        setLedger(onlyData || []);

      } catch (err) {
        console.error("Ledger fetch failed:", err);
      } finally {
        setLoadingLedger(false);
      }
    };

    loadLedger();
  }, [mid]);



const [showAepsPopup, setShowAepsPopup] = useState(false);

useEffect(() => {
    const popupSeen = localStorage.getItem("subscription_popup_seen");
    if (!popupSeen) {
      setShowSubscriptionPopup(true);
    }

    // 🚀 Check if AEPS 2 Pipe announcement has been viewed already
    const aepsPopupSeen = localStorage.getItem("aeps_pipe_announcement_seen");
    if (!aepsPopupSeen) {
      setShowAepsPopup(true);
    }
  }, []); 

const closeAepsPopup = () => {
    localStorage.setItem("aeps_pipe_announcement_seen", "true");
    setShowAepsPopup(false);
  };



  if (permissionDenied && !location) {
    return <LocationPopup />;
  }


  return (
    <div className="relative space-y-10 bg-[#f6f8fb] min-h-screen">
      <TickerBanner />


      {/* ================= NEW AEPS PIPE ANNOUNCEMENT POPUP ================= */}
      {/* {showAepsPopup && (
        <div className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex items-center justify-center px-4 animate-in fade-in duration-200">
          <div className="relative bg-white w-full max-w-lg rounded-3xl shadow-2xl overflow-hidden border border-slate-100">
            
            <div className="bg-gradient-to-r from-[#0A2A4F] to-[#1E4D8C] px-6 py-7 text-white relative">
              <button 
                onClick={closeAepsPopup}
                className="absolute top-4 right-4 bg-white/10 hover:bg-white/20 p-2 rounded-full text-white transition"
              >
                <X className="w-4 h-4" />
              </button>

              <div className="inline-flex items-center gap-1.5 bg-blue-400/20 border border-blue-300/30 text-blue-200 text-xs font-semibold px-3 py-1 rounded-full mb-3">
                <Sparkles className="w-3.5 h-3.5 text-yellow-300" />
                New Feature Update
              </div>

              <h2 className="text-2xl font-bold tracking-tight">
                Introducing New AEPS Route (AEPS 2) 🚀
              </h2>
              <p className="text-blue-100 text-sm mt-1">
                Enhanced reliability and faster transaction processing for your business.
              </p>
            </div>

            <div className="p-6 sm:p-7 space-y-5">
              <div className="bg-blue-50/60 border border-blue-100 rounded-2xl p-4 flex items-start gap-3.5">
                <div className="bg-blue-600 text-white p-2.5 rounded-xl shadow-xs mt-0.5">
                  <Zap className="w-5 h-5 text-yellow-300" />
                </div>
                <div>
                  <h4 className="text-sm font-bold text-slate-800">
                    Optimized for Transactions Under ₹5,000
                  </h4>
                  <p className="text-xs text-slate-600 mt-1 leading-relaxed">
                    We have successfully integrated a high-success-rate pipe inside <b>AEPS 2</b>. Try it out now for an exceptionally smooth, lightning-fast cash withdrawal experience for smaller amounts.
                  </p>
                </div>
              </div>

              <div className="space-y-2.5 text-xs text-slate-600 font-medium">
                <div className="flex items-center gap-2">
                  <ShieldCheck className="w-4 h-4 text-emerald-600" />
                  Higher success rates & minimal transaction drops
                </div>
                <div className="flex items-center gap-2">
                  <ShieldCheck className="w-4 h-4 text-emerald-600" />
                  Seamless routing switcher directly from your AEPS dashboard
                </div>
              </div>


              <div className="pt-2 flex gap-3">
                <button
                  onClick={closeAepsPopup}
                  className="flex-1 py-3 rounded-xl border border-slate-200 text-slate-700 font-semibold text-sm hover:bg-slate-50 transition"
                >
                  Got It, Thanks
                </button>
                <button
                  onClick={() => {
                    closeAepsPopup();
                    navigate("/aepsform2");
                  }}
                  className="flex-1 py-3 rounded-xl bg-gradient-to-r from-[#0A2A4F] to-[#1E4D8C] text-white font-semibold text-sm hover:opacity-95 transition shadow-md shadow-blue-900/20"
                >
                  Try AEPS 2 Now
                </button>
              </div>
            </div>

          </div>
        </div>
      )} */}


      {/* SUBSCRIPTION POPUP */}
{/* {showSubscriptionPopup && role === "MERCHANT" && (
  <div className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center px-4">

    <div className="relative bg-white w-full max-w-md rounded-3xl shadow-2xl overflow-hidden border border-[#12345A]/10">

      <div className="bg-[#12345A] px-6 py-8 text-center relative overflow-hidden">

        <div className="absolute -top-10 -right-10 w-32 h-32 bg-yellow-400/20 rounded-full" />
        <div className="absolute -bottom-10 -left-10 w-28 h-28 bg-yellow-300/20 rounded-full" />

        <div className="w-16 h-16 mx-auto rounded-full bg-gradient-to-br from-yellow-400 to-yellow-500 flex items-center justify-center shadow-lg border-4 border-white">
          <span className="text-3xl font-bold text-[#12345A]">
            ₹
          </span>
        </div>

        <h2 className="text-2xl font-bold text-white mt-4">
          Subscription Feature is Live 🚀
        </h2>

        <p className="text-sm text-slate-200 mt-2 leading-relaxed">
          Now enjoy more savings, extra benefits and premium features
          with our new subscription plans.
        </p>

      </div>


      <div className="px-6 py-6">

        <div className="space-y-3">

          <div className="flex items-start gap-3">
            <div className="text-yellow-500 text-lg">✔</div>
            <p className="text-sm text-slate-700">
              Better commission & cashback benefits
            </p>
          </div>

          <div className="flex items-start gap-3">
            <div className="text-yellow-500 text-lg">✔</div>
            <p className="text-sm text-slate-700">
              More savings on transactions
            </p>
          </div>

          <div className="flex items-start gap-3">
            <div className="text-yellow-500 text-lg">✔</div>
            <p className="text-sm text-slate-700">
              Priority access to upcoming premium features
            </p>
          </div>

        </div>

  
        <div className="mt-6 flex gap-3">

          <button
            onClick={closeSubscriptionPopup}
            className="flex-1 py-3 rounded-xl border border-slate-300 text-slate-600 font-medium hover:bg-slate-100 transition"
          >
            Later
          </button>

          <button
            onClick={() => {
              // closeSubscriptionPopup();

              navigate("/subscription");
            }}
            className="flex-1 py-3 rounded-xl bg-gradient-to-r from-[#12345A] to-[#1E4D8C] text-white font-semibold hover:opacity-90 transition shadow-lg"
          >
            Explore Plans
          </button>

        </div>

      </div>

    </div>

  </div>
)} */}

      {/* ================= WALLET OVERVIEW ================= */}
      <WalletOverview />
      
  

      {/* ================= MAIN CONTENT ================= */}
      <div className="space-y-6">

        {/* 🔥 SERVICES FULL WIDTH */}
        <div className="bg-white rounded-2xl">
          <ServiceHub />
        </div>

        {/* 🔥 RECENT TRANSACTION FULL WIDTH */}
        <div className="bg-white rounded-3xl border border-slate-200/80 shadow-xs overflow-hidden">
  {/* Card Header */}
  <div className="px-6 py-5 border-b border-slate-100 flex flex-wrap items-center justify-between gap-4">
    <div className="flex items-center gap-3">
      <div className="p-2.5 rounded-2xl bg-blue-50 text-blue-600 border border-blue-100/80">
        <ReceiptText className="w-5 h-5" />
      </div>
      <div>
        <h3 className="text-base font-bold text-slate-800 tracking-tight">
          Recent Transactions
        </h3>
        <p className="text-xs text-slate-400 font-medium mt-0.5">
          Real-time transaction history & ledger settlement
        </p>
      </div>
    </div>

    {/* Optional Header Counter Badge */}
    <div className="flex items-center gap-2">
      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-slate-50 text-slate-600 border border-slate-200/60">
        <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></span>
        Live Feed
      </span>
    </div>
  </div>

  {/* Responsive Modern Table */}
  <div className="overflow-x-auto">
    <table className="w-full text-left text-xs border-collapse">
      <thead>
        <tr className="bg-slate-50/75 border-b border-slate-100 text-slate-500 font-semibold tracking-wider uppercase text-[11px]">
          <th className="py-4 px-4 text-center w-16">Receipt</th>
          <th className="py-4 px-4">Date & Time</th>
          <th className="py-4 px-4">Transaction ID</th>
          <th className="py-4 px-4">Amount</th>
          <th className="py-4 px-4">Beneficiary / Consumer</th>
          <th className="py-4 px-4">Account / Identifier</th>
          <th className="py-4 px-4 text-center">Status</th>
        </tr>
      </thead>

      <tbody className="divide-y divide-slate-100 text-slate-600">
        {loadingLedger ? (
          <tr>
            <td colSpan="7" className="py-16 text-center text-slate-400">
              <div className="flex flex-col items-center justify-center gap-2.5">
                <Clock3 className="w-6 h-6 animate-spin text-blue-600" />
                <span className="text-xs font-medium">Fetching transaction ledger...</span>
              </div>
            </td>
          </tr>
        ) : ledger.length > 0 ? (
          ledger.map((r, i) => {
            const rawStatus = (r.txnStatus || r.status || "").toUpperCase();
            const isSuccess = rawStatus === "SUCCESS";
            const isFailed = rawStatus === "FAILED";

            return (
              <tr 
                key={i} 
                className="group hover:bg-slate-50/70 transition-colors duration-150"
              >
                {/* Print Action */}
                <td className="py-3.5 px-4 text-center">
                  <button
                    onClick={() => dispatch(openPrint(r))}
                    className="p-1.5 rounded-xl border border-slate-200 text-slate-600 hover:text-blue-600 hover:border-blue-200 bg-white hover:bg-slate-50 transition active:scale-95 inline-flex items-center gap-1 shadow-2xs cursor-pointer"
                    title="Print Receipt"
                  >
                    <Printer className="w-3.5 h-3.5" />
                    <span className="text-[11px] font-semibold">Print</span>
                  </button>
                </td>

                {/* Date */}
                <td className="py-3.5 px-4 whitespace-nowrap font-medium text-slate-700">
                  {r.date ? (
                    <div>
                      <div>{new Date(r.date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}</div>
                      <div className="text-[10px] text-slate-400 font-normal">
                        {new Date(r.date).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", second: "2-digit" })}
                      </div>
                    </div>
                  ) : "—"}
                </td>

                {/* Transaction ID */}
                <td className="py-3.5 px-4">
                  <div className="inline-flex items-center gap-1.5 font-mono text-[11px] font-medium text-slate-700 bg-slate-100/70 px-2 py-0.5 rounded-md border border-slate-200/40">
                    {r.txnId || "—"}
                  </div>
                </td>

                {/* Amount */}
                <td className="py-3.5 px-4 font-bold text-slate-900 text-sm whitespace-nowrap">
                  ₹{Number(r.netAmount ?? r.amount ?? 0).toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </td>

                {/* Beneficiary */}
                <td className="py-3.5 px-4 font-medium text-slate-800 max-w-[180px] truncate">
                  {r.transactionType === "INDO_NEPAL"
                    ? (r.fullName || r.consumerOrBeneficiary || "—")
                    : (r.consumerNumber || r.beneficiary_name || "—")}
                </td>

                {/* Account / Identifier */}
                <td className="py-3.5 px-4 font-mono text-slate-500">
                  {r.transactionType === "INDO_NEPAL"
                    ? (r.externalRefNo || "—")
                    : (r.beneficiary_account_number || r.aeps_AadhaarNo || "—")}
                </td>

                {/* Status Badge */}
                <td className="py-3.5 px-4 text-center whitespace-nowrap">
                  {isSuccess ? (
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200/80">
                      <CheckCircle2 className="w-3 h-3 text-emerald-600" />
                      SUCCESS
                    </span>
                  ) : isFailed ? (
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-semibold bg-rose-50 text-rose-700 border border-rose-200/80">
                      <XCircle className="w-3 h-3 text-rose-600" />
                      FAILED
                    </span>
                  ) : (
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[11px] font-semibold bg-amber-50 text-amber-700 border border-amber-200/80">
                      <AlertCircle className="w-3 h-3 text-amber-600" />
                      {rawStatus || "PENDING"}
                    </span>
                  )}
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="7" className="py-14 text-center text-slate-400">
              <div className="flex flex-col items-center justify-center gap-1.5">
                <ReceiptText className="w-8 h-8 text-slate-300 stroke-[1.5]" />
                <p className="text-xs font-semibold text-slate-500">No transactions recorded</p>
                <p className="text-[11px] text-slate-400">Recent customer activity will appear here.</p>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</div>

      </div>
      {!(mid === "sou4276_2330" && role === "MERCHANT") && (
        <div className="mt-8 sm:mt-10 md:mt-12 mb-8">
          <ImageCarousel />
        </div>
      )}
      <PrintPopup />
    </div>
  );

};

export default RetailerDashboard;
